import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

const FamiliplusBase = (): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', flexFlow: 'column' }}>
      <Box sx={{ flex: '1 1 auto' }}>
        <Box
          sx={{
            padding: { xs: '16px', sm: '24px' },
            minHeight: '100%',
            background: (theme) => theme.palette.background.main,
          }}>
          <Box sx={{ margin: '0 auto', maxWidth: '1030px' }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FamiliplusBase;
